export interface TipoBancoModel {
    value: string;
    descricao: string;
  }

export const tiposBancoList: TipoBancoModel[] = [

    {value: "001", descricao: "Banco do Brasil S.A."},
    {value: "033", descricao: "Banco Santander (Brasil) S.A."},
    {value: "104", descricao: "Caixa Econômica Federal"},
    {value: "237", descricao: "Banco Bradesco S.A."},
    {value: "341", descricao: "Banco Itaú S.A."},
    {value: "356", descricao: "Banco Real S.A. (antigo)"},
    {value: "389", descricao: "Banco Mercantil do Brasil S.A."},
    {value: "399", descricao: "HSBC Bank Brasil S.A. – Banco Múltiplo"},
    {value: "422", descricao: "Banco Safra S.A."},
    {value: "453", descricao: "Banco Rural S.A."},
    {value: "633", descricao: "Banco Rendimento S.A."},
    {value: "652", descricao: "Itaú Unibanco Holding S.A."},
    {value: "745", descricao: "Banco Citibank S.A."},
    {value: "246", descricao: "Banco ABC Brasil S.A"},
    {value: "025", descricao: "Banco Alfa S.A"},
    {value: "641", descricao: "Banco Alvorada S.A"},
    {value: "029", descricao: "Banco Banerj S.A"},
    {value: "038", descricao: "Banco Banestado S.A"},
    {value: "000", descricao: "Banco Bankpar S.A"},
    {value: "740", descricao: "Banco Barclays S.A"},
    {value: "107", descricao: "Banco BBM S.A"},
    {value: "031", descricao: "Banco Beg S.A"},
    {value: "096", descricao: "Banco BM&F de Serviços de Liquidação e Custódia S.A"},
    {value: "318", descricao: "Banco BMG S.A"},
    {value: "752", descricao: "Banco BNP Paribas Brasil S.A"},
    {value: "248", descricao: "Banco Boavista Interatlântico S.A"},
    {value: "036", descricao: "Banco Bradesco BBI S.A"},
    {value: "204", descricao: "Banco Bradesco Cartões S.A"},
    {value: "225", descricao: "Banco Brascan S.A"},
    {value: "044", descricao: "Banco BVA S.A"},
    {value: "263", descricao: "Banco Cacique S.A"},
    {value: "473", descricao: "Banco Caixa Geral – Brasil S.A"},
    {value: "222", descricao: "Banco Calyon Brasil S.A"},
    {value: "040", descricao: "Banco Cargill S.A"},
    {value: "M08", descricao: "Banco Citicard S.A"},
    {value: "M19", descricao: "Banco CNH Capital S.A"},
    {value: "215", descricao: "Banco Comercial e de Investimento Sudameris S.A"},
    {value: "756", descricao: "Banco Cooperativo do Brasil S.A. – BANCOOB"},
    {value: "748", descricao: "Banco Cooperativo Sicredi S.A"},
    {value: "505", descricao: "Banco Credit Suisse (Brasil) S.A"},
    {value: "229", descricao: "Banco Cruzeiro do Sul S.A"},
    {value: "003", descricao: "Banco da Amazônia S.A"},
    {value: "083-3", descricao: "Banco da China Brasil S.A"},
    {value: "707", descricao: "Banco Daycoval S.A"},
    {value: "M06", descricao: "Banco de Lage Landen Brasil S.A"},
    {value: "024", descricao: "Banco de Pernambuco S.A. – BANDEPE"},
    {value: "456", descricao: "Banco de Tokyo-Mitsubishi UFJ Brasil S.A"},
    {value: "214", descricao: "Banco Dibens S.A"},
    {value: "047", descricao: "Banco do Estado de Sergipe S.A"},
    {value: "037", descricao: "Banco do Estado do Pará S.A"},
    {value: "041", descricao: "Banco do Estado do Rio Grande do Sul S.A"},
    {value: "004", descricao: "Banco do Nordeste do Brasil S.A"},
    {value: "265", descricao: "Banco Fator S.A"},
    {value: "M03", descricao: "Banco Fiat S.A"},
    {value: "224", descricao: "Banco Fibra S.A"},
    {value: "626", descricao: "Banco Ficsa S.A"},
    {value: "394", descricao: "Banco Finasa BMC S.A"},
    {value: "M18", descricao: "Banco Ford S.A"},
    {value: "233", descricao: "Banco GE Capital S.A"},
    {value: "734", descricao: "Banco Gerdau S.A"},
    {value: "M07", descricao: "Banco GMAC S.A"},
    {value: "612", descricao: "Banco Guanabara S.A"},
    {value: "M22", descricao: "Honda S.A"},
    {value: "063", descricao: "Banco Ibi S.A. Banco Múltiplo"},
    {value: "M11", descricao: "Banco IBM S.A"},
    {value: "604", descricao: "Banco Industrial do Brasil S.A"},
    {value: "320", descricao: "Banco Industrial e Comercial S.A"},
    {value: "653", descricao: "Banco Indusval S.A"},
    {value: "630", descricao: "Banco Intercap S.A"},
    {value: "249", descricao: "Banco Investcred Unibanco S.A"},
    {value: "184", descricao: "Banco Itaú BBA S.A"},
    {value: "479", descricao: "Banco ItaúBank S.A"},
    {value: "M09", descricao: "Banco Itaucred Financiamentos S.A"},
    {value: "376", descricao: "Banco J. P. Morgan S.A"},
    {value: "074", descricao: "Banco J. Safra S.A"},
    {value: "217", descricao: "Banco John Deere S.A"},
    {value: "065", descricao: "Banco Lemon S.A"},
    {value: "600", descricao: "Banco Luso Brasileiro S.A"},
    {value: "755", descricao: "Banco Merrill Lynch de Investimentos S.A"},
    {value: "746", descricao: "Banco Modal S.A"},
    {value: "151", descricao: "Banco Nossa Caixa S.A"},
    {value: "045", descricao: "Banco Opportunity S.A"},
    {value: "623", descricao: "Banco Pavaluericano S.A"},
    {value: "611", descricao: "Banco Paulista S.A"},
    {value: "643", descricao: "Banco Pine S.A"},
    {value: "638", descricao: "Banco Prosper S.A"},
    {value: "747", descricao: "Banco Rabobank International Brasil S.A"},
    {value: "M16", descricao: "Banco Rodobens S.A"},
    {value: "072", descricao: "Banco Rural Mais S.A"},
    {value: "250", descricao: "Banco Schahin S.A"},
    {value: "749", descricao: "Banco Simples S.A"},
    {value: "366", descricao: "Banco Société Générale Brasil S.A"},
    {value: "637", descricao: "Banco Sofisa S.A"},
    {value: "464", descricao: "Banco Sumitomo Mitsui Brasileiro S.A"},
    {value: "082-5", descricao: "Banco Topázio S.A"},
    {value: "M20", descricao: "Banco Toyota do Brasil S.A"},
    {value: "634", descricao: "Banco Triângulo S.A"},
    {value: "208", descricao: "Banco UBS Pactual S.A"},
    {value: "M14", descricao: "Banco Volkswagen S.A"},
    {value: "655", descricao: "Banco Votorantim S.A"},
    {value: "610", descricao: "Banco VR S.A"},
    {value: "370", descricao: "Banco WestLB do Brasil S.A"},
    {value: "021", descricao: "BANESTES S.A. Banco do Estado do Espírito Santo"},
    {value: "719", descricao: "Banif-Banco Internacional do Funchal (Brasil)S.A"},
    {value: "073", descricao: "BB Banco Popular do Brasil S.A"},
    {value: "078", descricao: "BES Investimento do Brasil S.A.-Banco de Investimento"},
    {value: "069", descricao: "BPN Brasil Banco Múltiplo S.A"},
    {value: "070", descricao: "BRB – Banco de Brasília S.A"},
    {value: "477", descricao: "Citibank N.A"},
    {value: "081-7", descricao: "Concórdia Banco S.A"},
    {value: "487", descricao: "Deutsche Bank S.A. – Banco Alemão"},
    {value: "751", descricao: "Dresdner Bank Brasil S.A. – Banco Múltiplo"},
    {value: "062", descricao: "Hipercard Banco Múltiplo S.A"},
    {value: "492", descricao: "ING Bank N.V"},
    {value: "488", descricao: "JPMorgan Chase Bank"},
    {value: "409", descricao: "UNIBANCO – União de Bancos Brasileiros S.A"},
    {value: "230", descricao: "Unicard Banco Múltiplo S.A"},
    {value: "085", descricao: "COOP CENTRAL AILOS"},
    {value: "077", descricao: "BANCO INTER S.A"}
  ];
